window.TT=window.TT||function(s){var d=window.TT_JS;return (d&&d[s])||s;};
/* Cadeau-unlock (snippets/dw-gift-unlock.liquid)
   Werkt het cadeaublok bij op basis van het gekozen pakket (input[name="offer"][data-bundle])
   en geeft de te-ontgrendelen cadeau-variants door aan de koopknop via window.dwGiftItems(). */
(function () {
  function toArr(list) { return Array.prototype.slice.call(list); }
  function euro(cents) { return window.TT('€') + (cents / 100).toFixed(2).replace('.', ','); }

  function init() {
    var box = document.querySelector('[data-dwg-box]');
    if (!box) return;
    var radios = toArr(document.querySelectorAll('input[name="offer"]'));
    var cards = toArr(box.querySelectorAll('[data-dwg-gift]'));
    var stops = toArr(box.querySelectorAll('[data-dwg-stop]'));
    var teasers = toArr(document.querySelectorAll('[data-dwg-teaser]'));
    var bar = box.querySelector('[data-dwg-bar]');
    var count = box.querySelector('[data-dwg-count]');
    var total = box.querySelector('[data-dwg-total]');
    var word = box.querySelector('[data-dwg-word]');

    function tierOf(el) { return parseInt(el.getAttribute('data-tier'), 10) || 0; }
    function selected() {
      var r = radios.filter(function (x) { return x.checked; })[0];
      return r ? parseInt(r.getAttribute('data-bundle'), 10) || 0 : 0;
    }

    function update() {
      var b = selected();
      var open = 0;
      var sum = 0;
      cards.forEach(function (card, i) {
        var on = tierOf(card) <= b;
        card.classList.toggle('is-open', on);
        if (on) { open++; sum += parseInt(card.getAttribute('data-value'), 10) || 0; }
        var name = card.querySelector('[data-dwg-name]');
        var state = card.querySelector('[data-dwg-state]');
        if (name) name.textContent = on ? card.getAttribute('data-name') : window.TT('Cadeau ') + (i + 1);
        if (state) state.textContent = on ? window.TT('✓ Ontgrendeld') : card.getAttribute('data-unlock-label');
      });
      stops.forEach(function (s) {
        s.classList.toggle('is-on', parseInt(s.getAttribute('data-dwg-stop'), 10) <= b);
      });
      if (bar) bar.style.width = (stops.length > 1 ? Math.min(b, stops.length - 1) / (stops.length - 1) * 100 : 0) + '%';
      box.classList.toggle('has-open', open > 0);
      if (count) count.textContent = open + '/' + cards.length + window.TT(' cadeaus ontgrendeld');
      if (total) total.textContent = euro(sum);
      if (word) word.textContent = open ? window.TT('GRATIS ERBIJ') : window.TT('VERGRENDELD');
      teasers.forEach(function (tz) {
        var on = b >= (parseInt(tz.getAttribute('data-dwg-teaser'), 10) || 0);
        var txt = tz.querySelector('[data-dwg-teaser-txt]');
        tz.classList.toggle('is-open', on);
        if (txt) txt.textContent = txt.getAttribute(on ? 'data-open' : 'data-locked');
      });
    }

    // Gebruikt door initCart in dentalwipes.js: variant-ID's van de cadeaus die bij dit pakket horen.
    window.dwGiftItems = function (bundle) {
      var b = parseInt(bundle, 10) || 0;
      return cards
        .filter(function (c) { return tierOf(c) <= b && c.getAttribute('data-variant'); })
        .map(function (c) { return c.getAttribute('data-variant'); });
    };
    window.dwGiftDiscount = box.getAttribute('data-discount') || '';

    radios.forEach(function (r) { r.addEventListener('change', update); });
    update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
